import ImgLoading from "./../assets/images/loading.gif";
export default function Loading() {
    return(
        <div className="container-fluid">
            <div className="row justify-content-center">
                <div className="col-11 mt-5"><img className="img_loading" src={ImgLoading} alt="Cargando" />
                </div>
            </div>
        </div>
    )    
}